var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',{class:['fieldset', _vm.variant]},[(_vm.legend)?_c('legend',{staticClass:"fieldset__legend"},[_vm._v(" "+_vm._s(_vm.legend)+" ")]):_vm._e(),_c('div',{staticClass:"fieldset__body"},[_vm._t("fieldset-content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }